import { useClearRefinements } from 'react-instantsearch'

const useClearFacet = ({attributes}) => {
  const { refine: clearFacet } = useClearRefinements({
    includedAttributes: attributes,
  })
 
  return clearFacet
 }

export default useClearFacet